import RequestManager from "../RequestManager";

export default class Producer extends RequestManager {
    name!: string;
    logoURL!: string;
    catalogURL?: string;
}
